<authority-labs-check-case
  [inspection]="inspection"
  [fieldSection]="fieldSection"
  [printPreview]="printPreview"
  [hideConclusion]="hideConclusion"
  [hideNotes]="hideNotes"
  [readonly]="readonly"
  (dataChange)="onChange()"
>
  <mat-form-field floatLabel="always" appearance="fill" class="textarea">
    <mat-label>{{ label }}</mat-label>
    <textarea
      matInput
      cdkTextareaAutosize
      [drawableField]="
        (fieldSection || '') + ':' + (inspection?.title || '') + ':value'
      "
      [drawableFieldTitle]="label"
      [drawableFieldReadonly]="readonly"
      [(ngModel)]="inspection.value"
      [readonly]="readonly || printPreview"
      (input)="onChange()"
    ></textarea>
    <div
      matSuffix
      class="note-btns"
      *ngIf="!(readonly || printPreview) && notesBankType"
    >
      <button
        mat-icon-button
        aria-label="notes-bank"
        color="primary"
        (click)="showNotesBank($event)"
      >
        <mat-icon style="font-size: 20px">assignment</mat-icon>
      </button>
    </div>
  </mat-form-field>
</authority-labs-check-case>
